module.exports = __webpack_public_path__ + "img/logo-branco-refuturiza copy.8ad3dc72.svg";